<template>
    <div class="list-icon-btns">
        <i v-show="!publish"
           class="iconfont iconpublish"
           @click="onSubmit"
           style="color: #46B5FF"
        ></i>
        <i v-show="!publish" class="iconfont iconedit" @click="onEdit" style="color: #FF9C46"></i>
        <i v-show="publish" class="iconfont iconOff_shelf" @click="onUnPub"></i>
        <i v-show="!publish" class="iconfont icondelete" @click="onDel" style="color: #F34E1A"></i>
    </div>
</template>
<script>
    export default {
        props: {
            publish: {
                type: Boolean,
                default: true
            }
        },
        methods: {
            onSubmit() {
                this.$emit("on-submit");
            },
            onUnPub() {
                this.$emit("on-unpub");
            },
            onEdit() {
                this.$emit("on-edit");
            },
            onDel() {
                this.$emit("on-del");
            },
        },
    };
</script>
<style lang="less" scoped>
    .list-icon-btns {
        .iconfont {
            margin: 0 5px;
            font-size: 20px;

            &:hover {
                cursor: pointer;
            }
        }
    }
</style>
